<template>
  <v-tooltip location="top">
    <template #activator="{ props: tooltipProps }">
      <div class="app-mini-card" v-bind="tooltipProps" @click="handleClick">
        <div class="app-mini-card__title">{{ title }}</div>
        <div class="app-mini-card__description">{{ description }}</div>
      </div>
    </template>
    <div><strong>{{ name }}</strong></div>
    <div>{{ description }}</div>
  </v-tooltip>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  defaultValues: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['app_selected']);

function handleClick() {
  emit('app_selected', { name: props.name, defaultValues: props.defaultValues });
}
</script>

<style scoped lang="scss">
.app-mini-card {
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  background-color: #ffffff;
  transition: all 0.2s ease;
  width: 100%;

  &:hover {
    border-color: #0066cc;
    box-shadow: 0 2px 8px rgba(0, 102, 204, 0.1);
  }

  &__name {
    font-size: 11px;
    margin-bottom: 2px;
    color: #0066cc;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 4px;
    color: #0066cc;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__description {
    font-size: 12px;
    color: #666666;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
